"use strict";
import React from "react";
import { History } from "react-router";
import classNames from "classnames";
import { carrierInvoiceWithLoadPath } from "../flow_mode/dashboard_paths";
import loadHelper from "../loads";
export default React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {};
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__progress" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__container-ltl-reconcile" }, /* @__PURE__ */ React.createElement("ul", { className: "indexer-progress__list" }, this.renderReconcileInvoiceStep(), /* @__PURE__ */ React.createElement("li", { className: "indexer-progress__item indexer-progress__item--clickable indexer-progress__item__active" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator-inner" })), /* @__PURE__ */ React.createElement("span", null, "Review and Submit")))));
  },
  renderReconcileInvoiceStep: function() {
    const clickEnabled = !loadHelper.isMovedToTmsQueue(this.props.invoice);
    const classes = classNames({
      "indexer-progress__item": true,
      "indexer-progress__item--clickable": clickEnabled,
      "indexer-progress__item__completed": true
    });
    const onClick = clickEnabled ? this.redirectToReconcileInvoicePage : null;
    return /* @__PURE__ */ React.createElement("li", { className: classes, onClick }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator-inner" })), /* @__PURE__ */ React.createElement("span", null, "Reconcile Invoice"), /* @__PURE__ */ React.createElement("hr", { className: "indexer-progress__trailer" }));
  },
  redirectToReconcileInvoicePage: function() {
    const url = carrierInvoiceWithLoadPath(
      this.props.invoice.load_state_id,
      this.props.invoice.id,
      true
    );
    this.history.pushState(null, url.pathString(), {
      onDone: this.props.location.query.onDone
    });
  }
});
